import React from "react";

const InvoiceLineEditor = ({ lines, setLines, presets, label }) => {

  const addPresetLine = (text) => {
    setLines(prev => [
      ...prev,
      {
        id: crypto.randomUUID(),
        source: "preset",
        text
      }
    ]);
  };

  const addCustomLine = () => {
    setLines(prev => [
      ...prev,
      {
        id: crypto.randomUUID(),
        source: "custom",
        text: ""
      }
    ]);
  };

  const updateLine = (id, value) => {
    setLines(prev =>
      prev.map(line =>
        line.id === id ? { ...line, text: value } : line
      )
    );
  };

  const removeLine = (id) => {
    setLines(prev => prev.filter(line => line.id !== id));
  };

  return (
    <div className="invoice-line-editor">
      <h4>{label}</h4>

      <select onChange={(e) => e.target.value && addPresetLine(e.target.value)}>
        <option value="">Add from dropdown…</option>
        {presets.map(p => (
          <option key={p.id} value={p.text}>{p.text}</option>
        ))}
      </select>

      <button type="button" onClick={addCustomLine}>
        ➕ Add Custom Line
      </button>

      {lines.map(line => (
        <div key={line.id} style={{ display: "flex", gap: "8px", marginTop: "6px" }}>
          <textarea
            value={line.text}
            rows={line.source === "preset" ? 1 : 3}
            onChange={(e) => updateLine(line.id, e.target.value)}
            style={{ flex: 1 }}
          />
          <button type="button" onClick={() => removeLine(line.id)}>🗑</button>
        </div>
      ))}
    </div>
  );
};

export default InvoiceLineEditor;
